import { useState,useEffect,useRef } from 'react';
import GithubLogo from '../assets/img/github_logo.png';
import linkedinLogo from '../assets/img/linkedin_logo.png';
import MailIcon from "./MailIcon";
import cvIcon from "../assets/img/cv_logo.png";
import { useLanguage } from '../context/LanguageContext';

export const Home = () => {

    const { t } = useLanguage();

    // pequeña fujncion para que se coloore las partes del codigo
    function highlight(text) {
    return text
        .replace(/(\/\/.*)/g, `<span class="comment">$1</span>`)
        .replace(/\bfun\b/g, `<span class="keyword-fun">fun</span>`)
        .replace(/\bmain\b/g, `<span class="function-name">main</span>`);
    }


    // no vea si a costao
    const [loopNum, setLoopNum] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);
    const [text, setText] = useState('');
    const [toRotate] = useState([
        "Kotlin Developer",
        "Full-Stack Developer",
        "Back-End Developer",
        "C# Developer",
        "Java Developer",
        "Python Developer",
        "Compose Multiplatform Developer",
        "Spring Boot Developer",
        "Mobile App Developer",
        "Software Developer",
        "Game Developer",
        "Indie Game Developer",
        "UI/UX Enthusiast",
        "Creative Coder",
        "Problem Solver",
        "Tech Learner"
    ]);

    const timeoutRef = useRef(null);
    const loopRef = useRef(loopNum);
    const deletingRef = useRef(isDeleting);
    const textRef = useRef(text);

    useEffect(() => { loopRef.current = loopNum; }, [loopNum]);
    useEffect(() => { deletingRef.current = isDeleting; }, [isDeleting]);
    useEffect(() => { textRef.current = text; }, [text]);

    const writeSpeed = 120;
    const deleteSpeed = 60;

  // solo se ejjecuta una vez para que empiece a escribir y borrar
    useEffect(() => {
        const tick = () => {
            const i = loopRef.current % toRotate.length;
            const fullText = toRotate[i];

            const curText = textRef.current;
            const curDeleting = deletingRef.current;

            const updatedText = curDeleting
                ? fullText.substring(0, curText.length - 1)
                : fullText.substring(0, curText.length + 1);

            setText(updatedText);

            const nextDelay = curDeleting ? deleteSpeed : writeSpeed;

            if (!curDeleting && updatedText === fullText) {
                setIsDeleting(true);
            }

            else if (curDeleting && updatedText === '') {
                setIsDeleting(false);
                setLoopNum(prev => prev + 1);
            }

            timeoutRef.current = setTimeout(tick, nextDelay);
        };

        timeoutRef.current = setTimeout(tick, writeSpeed);

        return () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };

    }, [toRotate]);


    const renderedCode = [
        t.home.code1,
        `16 // ${text}|`,
        t.home.code2,
    ].join('\n');

    return (
    <div className="home-container" id="home">

        <div className="code-container">
            <div className="code-box">

                <div className="window-controls">
                    <span className="dot red"></span>
                    <span className="dot yellow"></span>
                    <span className="dot green"></span>
                </div>

                <pre>
                   <code dangerouslySetInnerHTML={{ __html: highlight(renderedCode) }} />
                </pre>
                
            </div>
        </div>

        <div className="icons-container">
            <MailIcon/>
            <a href='https://github.com/ftrugon'><img src={GithubLogo} alt='Github' width={100} height={100} /></a>
            <a href='https://www.linkedin.com/in/francisco-jose-trujillo-gonzalez-375438329/?skipRedirect=true'><img src={linkedinLogo} alt='Linkedin' width={100} height={100} /></a>
            <a href='/MyCv.pdf' download="Fran_cv.pdf"><img src={cvIcon} alt='CV' width={100} height={100}/></a>
        </div>
    </div>
    );
};

